import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { Popover, Icon } from 'antd';

import './component.css';


/*

  Сюда мы посылаем весь элемент, и плюс к этому его ширину относительную (в wv)

*/


export const Cip2025Cover = ({ sizes, element, client, children }) => {

    let style = {};

    let div_data = {}

    if (sizes.width) {

        if (sizes.dem) {
            style.width = `${sizes.width}${sizes.dem || ''}`
            style.height = `${sizes.width * 1.4}${sizes.dem || ''}`

            style.margin = sizes.nomargin ? 0 : `${sizes.width * 0.07}${sizes.dem || ''}`;
            style.padding = `${sizes.width * 0.07}${sizes.dem || ''}`

            style.fontSize = `${sizes.width / 8}${sizes.dem || ''}`
            style.lineHeight = `${sizes.width / 8}${sizes.dem || ''}`;
        } else {
            style.width = sizes.width;
            style.height = sizes.width * 1.4;

            style.margin = sizes.nomargin ? 0 : sizes.width * 0.07;
            style.padding = sizes.width * 0.07;

            style.fontSize = `${sizes.width / 7}px`;
            style.lineHeight = `${sizes.width / 6.5}px`;
        }
    }

    if (sizes.style) {
        style = { ...style, ...sizes.style }
    }

    if (sizes.reff) {
        div_data.ref = sizes.reff;
    }

    return <div className={'element-card card-cip2025-cover '} style={style} {...div_data} >
        <img src={client.getTechnicNeededLogo('covers/cip2025/bg')} />
        {children}
    </div>
}

export const Cip2025Content = (props) => {

    const { client, sizes, element_key } = props;

    const element = props.element;

    const {
        key,
        title,
        Tier,
        Points,
    } = element;


    let title_style = {
        fontSize: '75%',
        color: 'white'
    }

    // let w_koef = sizes.width ? sizes.width / 10 : 1;

    // if (title.length < 12) {
    //     //title_style.fontSize = `${ (12 / (title.length + 2)) * w_koef }vw`;
    //     title_style.fontSize = `${(1200 / (title.length + 2))}%`;
    // }

    return <div className='element-card-content card-cip2025-content'>

        <div className='card-cip2025-content-logo-img'>
            <img src={client.getTechnicLogoUrl(key)} />
        </div>

        <div className='card-cip2025-content-tier'>
            {`TIER ${Tier}`}
        </div>
        <div className='card-cip2025-content-points'>
            {`P: ${Points}`}
        </div>

        <div className='card-cip2025-content-title' style={title_style}>
            {title}
        </div>
    </div>
}